import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import FormContainer from "../components/FormContainer";
import { listGalleryDetails, updateGallery } from "../actions/galleryActions";
import { GALLERY_UPDATE_RESET } from "../constants/galleryConstants";

const GalleryEditScreen = ({ match, history }) => {
  const galleryId = match.params.id;

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const dispatch = useDispatch();

  const galleryDetails = useSelector((state) => state.galleryDetails);
  const { loading, error, gallery } = galleryDetails;

  const galleryUpdate = useSelector((state) => state.galleryUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = galleryUpdate;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: GALLERY_UPDATE_RESET });
      history.push("/gallerylist");
    } else {
      if (!gallery.title) {
        dispatch(listGalleryDetails(galleryId));
      } else {
        setTitle(gallery.title);
        setDescription(gallery.description);
      }
    }
  }, [dispatch, history, galleryId, gallery, successUpdate]);

  /*  const uploadFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post("/api/upload", formData, config);

      setImage(data);
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };*/

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      updateGallery({
        _id: galleryId,
        title,
        description,
      })
    );
  };

  return (
    <>
      <Link to="/gallerylist" className="btn btn-light my-3">
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit Gallery</h1>
        {loadingUpdate && <Loader />}
        {errorUpdate && <Message variant="danger">{errorUpdate}</Message>}
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="title">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="title"
                placeholder="Enter First Name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                type="description"
                placeholder="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Button type="submit" variant="primary">
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default GalleryEditScreen;
